import React, { useState } from "react";
import IconLogo from "../assets/icons/icons-r.png";
import { Link } from "react-router-dom";
import Bounce from "react-reveal";
export default function Navigation() {
	const [toggle, setToggle] = useState(false);

	const handlerToggler = () => setToggle(!toggle);
	console.log(toggle);
	return (
		<>
			<header className="container mx-auto mt-6 p-5 md:flex">
				<nav class="relative select-none bg-grey lg:flex lg:items-stretch w-full justify-between">
					<div class="flex flex-no-shrink items-stretch h-12">
						<Link
							to="/"
							class="flex-no-grow flex-no-shrink relative py-2 px-4 leading-normal text-white no-underline flex items-center hover:bg-grey-dark"
						>
							<img
								src={IconLogo}
								style={{ height: "70px" }}
								alt="Icon Website"
							/>
						</Link>

						<button
							class="block lg:hidden cursor-pointer ml-auto relative w-12 h-12 p-4"
							onClick={handlerToggler}
						>
							<svg
								class="fill-current text-white"
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 20 20"
							>
								<path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
							</svg>
						</button>
					</div>
					<Bounce top collapse when={!toggle}>
						<div class="lg:flex lg:items-stretch  lg:flex-no-shrink lg:flex-grow  ">
							<div class="block sm:hidden relative lg:flex lg:items-stretch lg:justify-end ml-auto">
								<Link
									to="/projects"
									class="flex-no-grow flex-no-shrink relative py-2 px-4 leading-normal text-white no-underline flex items-center hover:bg-grey-dark"
								>
									Project
								</Link>
								<Link
									to="/skills"
									class="flex-no-grow flex-no-shrink relative py-2 px-4 leading-normal text-white no-underline flex items-center hover:bg-grey-dark"
								>
									Skill
								</Link>
								<Link
									to="/contact"
									class="flex-no-grow flex-no-shrink relative py-2 px-4 leading-normal text-white no-underline flex items-center hover:bg-grey-dark"
								>
									Contact
								</Link>
								<Link
									to="/info"
									class="flex-no-grow flex-no-shrink relative py-2 px-4 leading-normal text-white no-underline flex items-center hover:bg-grey-dark"
								>
									About this webiste
								</Link>
							</div>
						</div>
					</Bounce>
				</nav>
			</header>
		</>
	);
}
